// extracted by mini-css-extract-plugin
export default {"details__checkBoxCell":"AdminOpcoRow_details__checkBoxCell__-a6kE"};